var _a, _b;
import { __assign, __spreadArray } from "tslib";
/**
 * KEEP IT DUMB AND SIMPLE
 */
import { handleActions } from 'redux-actions';
import { setIsLoading, storeResult } from './actionCreators';
import { reduxKey } from './constants';
var actionHandlers = handleActions((_a = {},
    _a[setIsLoading.toString()] = function (state, _a) {
        var endpoint = _a.payload;
        return (__assign(__assign({}, state), { loadingEndpoints: __spreadArray(__spreadArray([], state.loadingEndpoints, true), [endpoint], false) }));
    },
    _a[storeResult.toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, endpoint = _c.endpoint, result = _c.result;
        return (__assign(__assign({}, state), { loadingEndpoints: state.loadingEndpoints.filter(function (e) { return e !== endpoint; }), results: __assign(__assign({}, state.results), (_b = {}, _b[endpoint] = result, _b)) }));
    },
    _a), {
    loadingEndpoints: [],
    results: {},
});
var reducers = (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
export default reducers;
//# sourceMappingURL=reducer.js.map